// Shared `WineImport.*` i18n keys (used by WineImport.vue and the import button
// label in WineListing.vue). Kept as its own namespace because the Excel-import
// flow has its own UX strings that do not overlap with the catalog/listing keys.

export const wineImportDict: Record<string, [en: string, th: string]> = {
  "WineImport.pageTitle": ["Import Catalog from Excel", "นำเข้ารายการจาก Excel"],
  "WineImport.downloadTemplate": ["Download Import Template", "ดาวน์โหลดเทมเพลตนำเข้า"],
  "WineImport.uploadFile": ["Excel file from template", "ไฟล์ Excel ตามเทมเพลต"],
  "WineImport.import": ["Import", "นำเข้า"],
  "WineImport.importResult": ["Import Result", "ผลการนำเข้า"],
  "WineImport.importingWait": ["Import in progress — please wait until it finishes.", "กำลังนำเข้า — กรุณารอจนกว่าจะเสร็จ"],
};
